import { TestAttributes } from '@va/types/component';
import { Button, ButtonShapes } from '@va/ui/design-system';
import { ReactNode } from 'react';

type ActionButtonProps = {
  icon: ReactNode;
  tooltip: string;
  onClick: () => void;
} & TestAttributes;

type StatusTileActionsProps = {
  primaryAction: ActionButtonProps;
  secondaryAction: ActionButtonProps;
};

export function StatusTileActions({ primaryAction, secondaryAction }: StatusTileActionsProps) {
  return (
    <div className='flex gap-3px'>
      <Button
        size='small'
        color='quaternary'
        shape={ButtonShapes.custom}
        className={`rounded-l-9px`}
        icon={() => primaryAction.icon}
        onClick={(e) => {
          e.stopPropagation();
          primaryAction.onClick();
        }}
        tooltip={primaryAction.tooltip}
        data-testid={primaryAction['data-testid']}
      />
      <Button
        size='small'
        color='quaternary'
        shape={ButtonShapes.custom}
        className={`rounded-r-9px`}
        icon={() => secondaryAction.icon}
        onClick={(e) => {
          e.stopPropagation();
          secondaryAction.onClick();
        }}
        tooltip={secondaryAction.tooltip}
        data-testid={secondaryAction['data-testid']}
      />
    </div>
  );
}
